mutation RevokeSessionById($sessionId: ID!) {
	revokeSessionById(sessionId: $sessionId)
}
